import axios from 'axios'

import authenticationService from '@/services/authentication/authentication'

import { OpenAPI } from './client/requests'
import {
  attachAuthorizationHeaderInterceptor,
  attachMetaContextInterceptor,
  refreshIdTokenInterceptor,
} from './middlewares'

OpenAPI.BASE = import.meta.env.VITE_API_URL
OpenAPI.HEADERS = {}

OpenAPI.TOKEN = async () => (await authenticationService.getAccessToken()) ?? ''

OpenAPI.interceptors.request.use(async config => {
  const authed = await attachAuthorizationHeaderInterceptor(config)
  const updatedConfig = await attachMetaContextInterceptor(authed)

  OpenAPI.HEADERS = {
    ...OpenAPI.HEADERS,
    Authorization: updatedConfig.headers?.Authorization,
    'x-fb-browser-id': updatedConfig.headers?.['x-fb-browser-id'],
    'x-fb-click-id': updatedConfig.headers?.['x-fb-click-id'],
  }

  return updatedConfig
})

OpenAPI.interceptors.response.use(refreshIdTokenInterceptor)

export const getAxiosClient = () => {
  return axios.create({
    baseURL: OpenAPI.BASE,
    headers: { ...OpenAPI.HEADERS },
  })
}
